// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { Card } from '@mui/material';
import Flex from '@shared/components/Flex';
import CloseIcon from '@shared/icons/Close';

export interface ColumnProps {
  className?: string;
  classes?: Record<string, string>;
  heading: React.ReactNode;
  subHeading?: React.ReactNode;
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClose?: (e) => any;
}

class Column extends React.Component<ColumnProps> {
  render() {
    const { children, heading, subHeading, style, onClose } = this.props;
    const classes = withStyles.getClasses(this.props);

    return (
      <Card className={classes.root} style={style}>
        <Flex justifyContent="space-between" alignItems="center" className={classes.header}>
          <div>
            <p className={classes.heading}>{heading}</p>
            <p className={classes.subHeading}>{subHeading}</p>
          </div>
          {onClose && <CloseIcon className={classes.closeIcon} onClick={onClose} />}
        </Flex>
        {children}
      </Card>
    );
  }
}

const ColumnStyled = withStyles(
  Column, 
  (theme, props) => ({
    "root": {
      padding: 0,
      height: '85vh',
      maxHeight: 540,
    },
    "header": {
      height: 56,
      padding: theme.spacing(0, 4),
      borderBottom: `1px solid ${theme.palette.colors.greyLight}`,
    },
    "heading": {
      fontSize: 20,
      fontWeight: 500,
    },
    "subHeading": {
      color: theme.palette.colors.greyDark,
      fontSize: 11,
    },
    "closeIcon": {
      fontSize: 18,
  
      '& path': {
        fill: theme.palette.colors.grey,
      },
    }
  })
);

export default ColumnStyled;